import { render } from "./TablePagination.vue?vue&type=template&id=31da1a82&scoped=true"
import script from "./TablePagination.vue?vue&type=script&lang=js"
export * from "./TablePagination.vue?vue&type=script&lang=js"

import "./TablePagination.vue?vue&type=style&index=0&id=31da1a82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31da1a82"]])

export default __exports__